import React from 'react';
import { Badge, Table } from 'react-bootstrap';
import { showUtcClock } from '../../utils/utcDateTime';

// Every lever, forever: who pulled it, on what, why, when. Accountability
// is per person — the row names the actor, never a shared login. Who can
// pull levers at all is the service allowlist (ADMIN_WALLETS), set by
// Venom at deploy.
const ACTION_BADGE = {
  freeze: 'info',
  unfreeze: 'success',
  revoke: 'danger',
  'disable-batch': 'danger',
  'enable-batch': 'success',
  'disable-code': 'secondary',
  'enable-code': 'success',
  mint: 'warning',
  'wave-close': 'info',
  'settings-edit': 'secondary',
};

/** UTC clock, plus a local secondary only when the browser zone differs. */
export const showAuditWhen = showUtcClock;

const AuditPanel = ({ actions }) => (
  <div className="waitlist-panel">
    <h5>Audit trail</h5>
    <div className="text-muted small mb-2">
      Every lever, forever. Rows are permanent — nothing is ever deleted.
    </div>
    <Table hover responsive size="sm">
      <thead>
        <tr>
          <th>When (UTC)</th>
          <th>Who</th>
          <th>Action</th>
          <th>Target</th>
          <th>Reason</th>
        </tr>
      </thead>
      <tbody>
        {actions.map(a => (
          <tr key={a.id}>
            <td className="text-muted">{showAuditWhen(a.at)}</td>
            <td className="fw-semibold">{a.actor}</td>
            <td>
              <Badge bg={ACTION_BADGE[a.action] ?? 'secondary'}>{a.action}</Badge>
            </td>
            <td className="text-muted">{a.target}</td>
            <td>{a.reason}</td>
          </tr>
        ))}
        {actions.length === 0 && (
          <tr>
            <td colSpan={5} className="text-center text-muted py-4">
              No actions yet.
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  </div>
);

export default AuditPanel;
